import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {AuthSearchParams} from './constants';

export const useAuthenticationOpenState = ({
  enableParams,
}: {enableParams?: boolean} = {}) => {
  const params = enableParams
    ? [
        {
          urlSearchParam: AuthSearchParams.LoginFlow,
          allowedValues: ['login', 'register'],
        },
      ]
    : [];

  if (enableParams) {
    params.push({
      urlSearchParam: AuthSearchParams.LoginReason,
      allowedValues: ['personal-reduction', 'coupon'],
    });
  }

  const {open, ...rest} = useOpenedStateManager('AUTHENTICATED_MODAL', {
    controlParams: params,
    replaceHistoryOnAutoOpen: enableParams,
  });

  return {
    ...rest,
    open: ({
      parameter = 'login',
      replaceHistory,
    }: {
      replaceHistory?: boolean;
      parameter?: string;
    } = {}) => open({parameter, replaceHistory}),
  };
};
